const handleFileUpload = (e, arrayHelpers, index, docPerKind) => {
  arrayHelpers.replace(index, {
    id: docPerKind?.id,
    doc_id: docPerKind?.doc_id,
    // Convert filelist to array
    files: [...e.target.files],
  });
};

export default handleFileUpload;
